module.exports = __webpack_public_path__ + "img/lipin.9e3cc389.png";